import { withProps, mapProps } from 'recompose'
import { Field } from 'formik'
import NumberFormat from 'react-number-format'
import TextField from '@material-ui/core/TextField'

const NumberField = mapProps(({ form, field, options, ...props }) => ({
  ...props,
  thousandSeparator: '.',
  decimalSeparator: ',',
  customInput: TextField,
  value: field.value,
  onBlur: () => form.setFieldTouched(field.name, true),
  onValueChange: values =>
    form.setFieldValue(field.name, values.floatValue || '')
}))(NumberFormat)

export default withProps({ component: NumberField })(Field)
